import React from 'react'
import * as S from '../uploadFileModalWindow.style'
import { fileTableTitles } from '../../ColaSourceTab/config/configs'
import { FileTableRow } from '../../ColaSourceTab/FileTableRow'
import Table from 'uiKit/table/Table'
import { FileData } from '../file-upload'

interface UploadFileTableProps {
  onDelete: any
  onBlurHandle: any
  files: FileData[]
}

export const UploadFileTable: React.FC<UploadFileTableProps> = ({ onDelete, onBlurHandle, files }) => {
  return (
    <>
      <Table titles={fileTableTitles}>
        {files.map((source, index) => (
          <FileTableRow
            key={source._id}
            sources={source}
            index={index}
            isDownloadEnabled={false}
            onBlurHandle={onBlurHandle}
            onDelete={onDelete}
            textNotEditable={true}
          />
        ))}
      </Table>
    </>
  )
}
